import { computed, onMounted, onUnmounted, ref, Ref } from 'vue'

// reactive ตาม window width เพื่อให้ grid ปรับ layout ทันทีตอนหมุนจอ/ปรับขนาดหน้าจอ
// ไม่ต้อง refresh หน้าใหม่เหมือนของเดิมที่คำนวณครั้งเดียวตอน mount
export function useResponsiveGrid() {
  const windowWidth: Ref<number> = ref(window.innerWidth)
  const chunksize = computed(() =>
    Math.max(1, Math.floor(windowWidth.value / 180)),
  )
  const span = computed(() => Math.floor(24 / chunksize.value))

  function onWindowResize() {
    windowWidth.value = window.innerWidth
  }

  onMounted(() => window.addEventListener('resize', onWindowResize))
  onUnmounted(() => window.removeEventListener('resize', onWindowResize))

  return { windowWidth, chunksize, span }
}

// เติมช่องว่างในแถวสุดท้ายให้เต็มแถวเสมอ ไม่งั้น van-row justify="center"
// จะดันของเหลือไปอยู่กลางแถวแทนที่จะชิดซ้าย
export function chunkGrid<T>(
  items: T[],
  chunksize: number,
  emptyItem: T,
): T[][] {
  if (!items || items.length === 0) return []

  const chunk: T[][] = []
  for (let i = 0; i < items.length; i += chunksize) {
    chunk.push(items.slice(i, i + chunksize))
  }

  const lastChunk = chunk[chunk.length - 1]
  if (lastChunk.length % chunksize < chunksize) {
    const fill_in_size = chunksize - lastChunk.length
    for (let i = 0; i < fill_in_size; i++) {
      lastChunk.push(emptyItem)
    }
  }

  return chunk
}
